import axios from "axios";

const api = axios.create({
  timeout: 0,
  headers: {
    "Content-Type": "application/json",
    "Accept": "application/json",
  },
});

const isDesenvolvimento = process.env.NODE_ENV === "development";
const API_PAINEL_URL = isDesenvolvimento ? "https://painel.gamadelivery.app/api-dev.php" : "api.php";
const API_PAINEL_GAMA_MASTER = "https://painel.gamadelivery.app/master.php";

/*** API ***/

/*** API GAMADELIVERY ***/
export const loginSistema = (cliente, identificacao, token) => `https://${cliente}${identificacao}/app/authorization/?token=${token}`;
export const alterarVencimentoSistema = async (cliente, identificacao, body) => await api.post(`https://${cliente}${identificacao}/app/vencimento/`, body);
export const enviarNotificacaoSistema = async (cliente, identificacao, body) => await api.post(`https://${cliente}${identificacao}/app/notificacao/`, body);
export const alterarResponsavelSistema = async (cliente, identificacao, body) => await api.post(`https://${cliente}${identificacao}/app/responsavel/`, body);
export const alterarDadosClienteSistema = async (cliente, identificacao, body) => await api.post(`https://${cliente}${identificacao}/app/cliente/`, body);
export const alterarInformativoDoCliente = async (cliente, identificacao, body) => await api.post(`https://${cliente}${identificacao}/app/informacao/`, body);

/*** API DO CADASTRO ***/
export const cadastrarSistema = async (identificacao, body) => await api.post(`https://cadastro${identificacao}/`, body);
export const alterarVersaoSistema = async (identificacao, body) => await api.post(`https://cadastro${identificacao}/`, body);
export const removerSistema = async (identificacao, body) => await api.post(`https://cadastro${identificacao}/`, body);
export const desbloquearSistema = async (identificacao, body) => await api.post(`https://cadastro${identificacao}/`, body);

/*** API ASAAS ***/
export const asaasListarFaturas = async (token, cliente) => await api.get(`${API_PAINEL_URL}?token=${token}&faturas=${cliente}`);
export const asaasCriarFatura = async (token, fatura) => await api.get(`${API_PAINEL_URL}`, {
  params: { token: token, gerarFatura: JSON.stringify(fatura) },
});

/*** API RESPONSÁVEL ***/
export const autenticarApiClientes = async (token, pin) => await api.post(API_PAINEL_URL, {
  token: token,
  pin: pin,
});
export const fetchApiClientes = async (token) => await api.get(`${API_PAINEL_URL}?token=${token}&clientes=true`);
export const responsavelGeralDados = async (token) => await api.get(`${API_PAINEL_URL}?token=${token}&responsavel=true`);
export const responsavelGeralSalvar = async (token, responsavel) => await api.get(API_PAINEL_URL, {
  params: { token: token, responsavelSalvar: JSON.stringify(responsavel) },
});

/*** GAMAZAP ***/
export const verificarInstanciaGamazap = async (token) => await api.get(API_PAINEL_URL, {
  params: { token: token, verificarInstancia: true },
});
export const iniciarInstanciaGamazap = async (token) => await api.get(API_PAINEL_URL, {
  params: { token: token, gerarInstancia: true },
});
export const enviarMensagem = async (token, telefone, mensagem) => await api.get(API_PAINEL_URL, {
  params: { token: token, enviarMensagem: true, telefone: telefone, mensagem: mensagem },
});

/*** GAMAZAP SERVERS ***/
export const listarInstancias = async (token, server) => await api.get(API_PAINEL_URL, {
  params: { token: token, listarInstancias: true, server: server },
});
export const removerInstancia = async (token, server, instance) => await api.get(API_PAINEL_URL, {
  params: { token: token, removerInstancia: true, server: server, instance: instance },
});

/*** TICKETS ***/
export const listarTickets = async (token) => await api.get(API_PAINEL_URL, {
  params: { token: token, listarTickets: true },
});
export const abrirTicket = async (token, assunto, descricao) => await api.get(API_PAINEL_URL, {
  params: { token: token, abrirTicket: true, assunto: assunto, descricao: descricao },
});

/*** ASSISTENTE ***/
export const questionarTutorial = async (token, assunto) => await api.get(API_PAINEL_URL, {
  params: { token: token, questionarTutorial: true, assunto: assunto },
});

/*** MASTER ***/
export const listarInstalacoes = async (token) => await api.get(API_PAINEL_URL, {
  params: { token: token, listarInstalacoes: true },
});
export const listarRevendas = async (token) => await api.get(API_PAINEL_URL, {
  params: { token: token, listarRevendas: true },
});
export const listarTransacoes = async (token) => await api.get(API_PAINEL_URL, {
  params: { token: token, listarTransacoes: true },
});
export const desbloquearIp = async (token, ip) => await api.get(API_PAINEL_URL, {
  params: { token: token, desbloquearIp: true, ip: ip },
});
export const alternarBloqueioPainel = async (token) => await api.get(API_PAINEL_URL, {
  params: { token: token, bloquear: true },
});
export const validarRevenda = async (url, nome) => await api.get(API_PAINEL_GAMA_MASTER, {
  params: { validarRevenda: true, url: url, nome: nome },
});
export const usarCreditos = async (url, creditos) => await api.get(API_PAINEL_GAMA_MASTER, {
  params: { usarCreditos: true, url: url, creditos: creditos },
});